<template>
  <div class="study-status">
    <el-card>
      <h2>学习情况</h2>

      <!-- 总学习时长和完成率 -->
      <el-row>
        <el-col :span="12">
          <el-card>
            <h3>本月学习时长</h3>
            <p>{{ (learnStatus.totaltime / 60).toFixed(1) }} 分钟</p>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <h3>学习完成率</h3>
            <p>{{ learnStatus.wcl.toFixed(1) }}%</p>
          </el-card>
        </el-col>
      </el-row>

      <!-- 详细学习计划表 -->
      <el-table :data="learnStatus.learndetails" border style="width: 100%" class="mt-20">
        <el-table-column prop="planName" label="培训计划" width="300"></el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="endDate" label="结束时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>

        <el-table-column prop="learnedTime" label="学习时长 (分钟)" width="150">
          <template #default="scope">
            {{ (scope.row.learnedTime / 60).toFixed(1) }}
          </template>
        </el-table-column>

        <el-table-column prop="kansei" label="是否看完" width="300"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  props: {
    userid: {
      type: Number, // 用户ID
      required: true,
    },
    organizationID: {
      type: Number, // 机构ID
      required: true,
    },
  },
  data() {
    return {
      learnStatus: {
        totaltime: 0, // 学习总时长 (秒)
        wcl: 0, // 完成率 (%)
        learndetails: [], // 学习详情列表
      },
    };
  },
  methods: {
// 格式化日期，仅显示 YYYY-MM-DD
    formatDate(date) {
      if (!date) return ""; // 确保日期存在
      const d = new Date(date); // 将字符串转换为 Date 对象
      const year = d.getFullYear(); // 获取年份
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 获取月份并补零
      const day = String(d.getDate()).padStart(2, "0"); // 获取日期并补零
      return `${year}-${month}-${day}`; // 拼接为 YYYY-MM-DD 格式
    },

    // 获取学习状态
    fetchLearnStatus() {
      const userid = this.userid;
      const organizationID = this.organizationID;

      axios
          .get("/user-watch-history/learnstatus", {params: {userid, organizationID}})
          .then((response) => {
            this.learnStatus = response.data.data;
          })
          .catch((error) => {
            console.error("获取学习状态失败:", error);
            ElMessage.error("获取学习状态失败，请重试！");
          });
    },
  },
  created() {
    // 初始化时获取学习状态
    this.fetchLearnStatus();
  },
};
</script>

<style scoped>
.study-status {
  padding: 20px;
}

.mt-20 {
  margin-top: 20px;
}
</style>
